import { Fab, FormControlLabel, Switch } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { FC, useState } from 'react';
import UnderwritingTemplate from '../../../components/templates/UnderwritingTemplate';
// import PathsModal, { pathFilters } from "../components/organisms/PathsModal/PathsForm";
import { PathsModal } from './PathsViewModal';
import UnderwritingTable from '../../../components/organisms/DataTable/UnderwritingTable';
import { MUIDataTableColumn } from 'mui-datatables';
import { arrayFormat, dateFormat, truncatedArrayFormat } from '../../../utils/formatting';
import { useGetApiV1UnderwritingPathsQuery } from '../hooks';
import Loading from '../../../components/atoms/Loading';
import { factory } from '../utils/factory';
import React from 'react';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import { Pathtypesenum } from '../../../constants/data_arrays';

export const pathsColumns: MUIDataTableColumn[] = [
  {
    name: 'pathId',
    label: 'ID',
    options: {
      display: 'false',
    },
  },
  {
    name: 'name',
    label: 'Path Name',
  },
  {
    name: 'activeStart',
    label: 'Start date',
    options: {
      filter: false,
      customBodyRender: dateFormat,
    },
  },
  {
    name: 'activeEnd',
    label: 'End date',
    options: {
        customBodyRender: dateFormat,
        filterType: 'custom',
        filterOptions: {
        logic: (activeEnd, filters) => {
            if (filters[0] === 'All') {
            return false;
            } else {
            return moment(activeEnd).isBefore(moment());
            }
        },
        display: (filterList, onChange, index, column) => {
            return (
            <FormControlLabel
                control={
                <Switch
                    checked={filterList[index][0] !== 'All'}
                    onClick={(e) => {
                    if (filterList[index][0] === 'All') {
                        filterList[index][0] = 'Active';
                    } else {
                        filterList[index][0] = 'All';
                    }
                    onChange(filterList[index], index, column);
                    }}
                />
                }
              label="Show Only Active Paths"
            />
          );
        },
      },
    },
  },
  {
    name: 'states',
    label: 'Locations',
    options: {
      filterType: 'dropdown',
      customBodyRender: arrayFormat,
    },
  },
  {
    name: 'origins',
    label: 'Origins',
    options: {
      filterType: 'dropdown',
      customBodyRender: truncatedArrayFormat,
    },
  },
  {
    name: 'paycycles',
    label: 'Paycycles',
    options: {
      filterType: 'dropdown',
      customBodyRender: truncatedArrayFormat,
    },
  },
];

type PATH_VIEW = number | 'CREATE';
const PathsView: FC = (props) => {
  const [pathModal, setPathModal] = useState<PATH_VIEW>();
  const pathsQuery = useGetApiV1UnderwritingPathsQuery();
  const params= useParams();
  const paramsvalue  = Object.keys(params).length >0  ? params : {name : Pathtypesenum[Pathtypesenum.Regular]}
  const pathTable = React.useMemo(() => {
    // right now this is the efficient way I know how to do this.. will reimprove this
    if (pathsQuery.isSuccess) {
      const path = pathsQuery.data.map((x) => factory.fromPathToInput(x));
      return path.filter(x=>x.pathType === paramsvalue?.name);
    } else {
      return [];
    }
  }, [pathsQuery,paramsvalue.name]);

  if (!pathsQuery.isSuccess) {
    return <Loading />;
  }
  return (
    <UnderwritingTemplate
      tableArea={
        <UnderwritingTable
          loading={pathsQuery.isLoading}
          data={pathTable}
          title={'Path Table'}
          onRowClick={(m) => setPathModal(m)}
          columns={pathsColumns}
          options={{ filterType: 'textField' }}
        />
      }
      modalActions={
        <>
          {
            // kind of redundant
            pathModal && (
              <>
                {pathModal !== 'CREATE' ? (
                  <PathsModal.Edit
                    handleClose={() => setPathModal(undefined)}
                    path={pathModal}
                     onDuplicateSuccess={() => pathsQuery.refetch()}
                  />
                ) : (
                  <PathsModal.Create
                    handleClose={() => setPathModal(undefined)}
                    path={pathModal}
                  />
                )}
              </>
            )
          }

          <div style={{ position: 'fixed', bottom: 24, right: 24 }}>
            <Fab
              onClick={() => setPathModal('CREATE')}
              color="secondary"
              aria-label="add-path">
              <AddIcon />
            </Fab>
          </div>
        </>
      }
    />
  );
};
export default PathsView;

